
import _ from 'lodash';
import trimTrailingParagraph from 'shared/lib/trimTrailingParagraph';
import {
  SALARY_RANGE_MAX_DIFF,
  RATE_PERIOD,
  HOURLY_RATE_MIN,
  HOURLY_RATE_MAX,
  DAILY_RATE_MIN,
  DAILY_RATE_MAX,
  MONTHLY_RATE_MIN,
  MONTHLY_RATE_MAX,
  YEARLY_RATE_MIN,
  YEARLY_RATE_MAX,
} from 'shared/constants';

const emailRegexp = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
const numberRegexp = /^[0-9]+[.]?[0-9]{0,}$/;
const numericRegexp = /^[0-9]+[0-9 ]+$/;
const integerValid = /^[1-9]+[0-9]{0,}$/;
const urlRegexp = /^http[s]{0,1}:\/\/.*\.[a-z]{2,}.*$/;
const phoneRegexp = /^[+0]?[0-9]{9,}$/;
export const isEmailValid = email => emailRegexp.test(email);
export const isStringValid = str => (str || '').toString().trim().length > 0;
export const isWysiwygStringValid = string => isStringValid(trimTrailingParagraph(string));
export const isNumberValid = str => _.isNumber(str) || numberRegexp.test(str);
export const isNumericValid = str => numericRegexp.test(str);
export const isIntegerValid = str => _.isInteger(str) || integerValid.test(str);
export const isUrlValid = str => urlRegexp.test(str);
export const isPhoneValid = str => phoneRegexp.test(str);
export const isValidRateRange = (from, to) => {
  if (~~from > ~~to) {
    return false;
  }

  const diff = Math.abs(100 - Math.floor(to / from * 100));
  return diff <= SALARY_RANGE_MAX_DIFF;
};
export const isSomeLangVersionStringValid = (entity = {}, modifier = str => str) =>
  Object.keys(entity).some(lng => isStringValid(modifier(entity[lng])));

export const isValidRateAmountAboveMinimum = (rate, ratePeriod) => {
  const rateAmount = ~~rate;
  const ratePeriodId = ~~ratePeriod;

  return (ratePeriodId === RATE_PERIOD.HOURLY && rateAmount >= HOURLY_RATE_MIN)
  || (ratePeriodId === RATE_PERIOD.DAILY && rateAmount >= DAILY_RATE_MIN)
  || (ratePeriodId === RATE_PERIOD.MONTHLY && rateAmount >= MONTHLY_RATE_MIN)
  || (ratePeriodId === RATE_PERIOD.YEARLY && rateAmount >= YEARLY_RATE_MIN);
};

export const isValidRateAmountUnderMaximum = (rate, ratePeriod) => {
  const rateAmount = ~~rate;
  const ratePeriodId = ~~ratePeriod;

  return (ratePeriodId === RATE_PERIOD.HOURLY && rateAmount <= HOURLY_RATE_MAX)
  || (ratePeriodId === RATE_PERIOD.DAILY && rateAmount <= DAILY_RATE_MAX)
  || (ratePeriodId === RATE_PERIOD.MONTHLY && rateAmount <= MONTHLY_RATE_MAX)
  || (ratePeriodId === RATE_PERIOD.YEARLY && rateAmount <= YEARLY_RATE_MAX);
};

export default {
  isEmailValid,
  isStringValid,
  isWysiwygStringValid,
  isNumberValid,
  isNumericValid,
  isIntegerValid,
  isUrlValid,
  isValidRateRange,
  isSomeLangVersionStringValid,
};
